import {
  createISOStrDateUtil,
  logUtil
} from 'packages/src'
import {
  getCurrentProfileSelect,
  runAfterDelayPromisifiedPerformanceUtil
} from '@gymaholic/packages'
import {
  PROFILE_FITNESS_DATA_MODAL_DELAY_APP_ROUTE_IN_SECONDS,
  PROFILE_FITNESS_DATA_MODAL_DELAY_IN_SECONDS,
  PROFILE_FITNESS_DATA_MODAL_NEW_PROFILE_WITH_INCOMPLETE_DATA_IN_SECONDS
} from 'modules/profile/constants/index.js'
import { hasSeenOnboardingModalRecentlyProfileUtil } from 'modules/profile/utils/hasSeenOnboardingModalRecently/index.js'
import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string/index.js'
import getSearchRouterSelect from 'modules/router/selectors/get-search/index.js'
import { APP_QUERY_PARAMETER } from 'modules/app/constants/index.js'
import isPremiumUrlRouterSelect from 'modules/router/selectors/is-premium/index.js'
import hasModalSelect from 'modules/modal/selectors/has-modal/index.js'
import isStartWorkoutUrlRouterSelect from 'modules/router/selectors/is-start-workout-url/index.js'
import hasCompletedFitnessDataProfileSelect from '@gymaholic/packages/src/modules/profile/redux/selectors/has-completed-fitness-data/index.js'
import { isPlanUrlRouterSelect } from 'modules/router/selectors/is-plan-url/index.js'
import { isWorkoutUrlRouterSelect } from 'modules/router/selectors/is-workout-url/index.js'
import { isAnAppRouteSelect } from 'modules/router/selectors/isAnAppRoute/index.js'
import { createProfileAction } from 'modules/profile/redux/actions/create/index.js'
import isInLinksRouteSelect from 'modules/router/selectors/is-in-links/index.js'
import { updateProfileFitnessDataModalShownAtAction } from 'modules/profile/redux/actions/updateProfileFitnessDataModalShownAt/index.js'

export const PROFILE_FITNESS_DATA_MODAL_SHOWN_AT_DIFF_HOURS = 1

export function shouldShowOnboardingModalProfileAction () {
  return async (dispatch, getState) => {
    const search = getSearchRouterSelect(getState())
    const queryParams = getQueryParamsFromStringObjectUtil(search)

    const debugProps = {
      search,
      queryParams
    }

    logUtil('shouldShowOnboardingModalProfileAction').debug('[start] debugProps=', debugProps)

    const isForced = queryParams?.[APP_QUERY_PARAMETER.SHOW_ONBOARDING] === 'true'
    if (isForced) {
      return true
    }

    const hasCurrentProfile = !!getCurrentProfileSelect(getState())
    const hasCompletedFitnessData = hasCompletedFitnessDataProfileSelect(getState())
    const isNewProfileWithIncompleteData = hasCurrentProfile && !hasCompletedFitnessData
    dispatch(createProfileAction())

    debugProps.hasCurrentProfile = hasCurrentProfile
    debugProps.hasCompletedFitnessData = hasCompletedFitnessData
    debugProps.isNewProfileWithIncompleteData = isNewProfileWithIncompleteData
    logUtil('shouldShowOnboardingModalProfileAction').debug('[start] debugProps=', debugProps)

    const hasSeenRecently = hasSeenOnboardingModalRecentlyProfileUtil()
    if (hasSeenRecently) {
      logUtil('shouldShowOnboardingModalProfileAction').debug('[noop] already seen recently')
      return
    }

    const openModalWithDelay = async () => {
      const isAnAppRoute = isAnAppRouteSelect(getState())
      let delay
      if (isNewProfileWithIncompleteData) {
        delay = PROFILE_FITNESS_DATA_MODAL_NEW_PROFILE_WITH_INCOMPLETE_DATA_IN_SECONDS
      } else if (isAnAppRoute) {
        delay = PROFILE_FITNESS_DATA_MODAL_DELAY_APP_ROUTE_IN_SECONDS
      } else {
        delay = PROFILE_FITNESS_DATA_MODAL_DELAY_IN_SECONDS
      }

      logUtil('shouldShowOnboardingModalProfileAction').debug(`[openModalWithDelay] delay=${delay}`)
      await runAfterDelayPromisifiedPerformanceUtil({
        delay
      })

      if (hasModalSelect(getState())) {
        logUtil('shouldShowOnboardingModalProfileAction').debug('[noop] has modal, trying again in a bit')
        return openModalWithDelay()
      }

      if (isPremiumUrlRouterSelect(getState())) {
        logUtil('shouldShowOnboardingModalProfileAction').debug('[noop] is premium')
        return false
      }

      if (isStartWorkoutUrlRouterSelect(getState())) {
        logUtil('shouldShowOnboardingModalProfileAction').debug('[noop] workout started')
        return false
      }

      if (isWorkoutUrlRouterSelect(getState())) {
        logUtil('shouldShowOnboardingModalProfileAction').debug('[noop] workout url')
        return false
      }

      if (isPlanUrlRouterSelect(getState())) {
        logUtil('shouldShowOnboardingModalProfileAction').debug('[noop] plan url')
        return false
      }

      if (isInLinksRouteSelect(getState())) {
        logUtil('shouldShowOnboardingModalProfileAction').debug('[noop] is in links')
        return false
      }

      if (hasCompletedFitnessDataProfileSelect(getState())) {
        logUtil('shouldShowOnboardingModalProfileAction').debug('[noop] already completed')
        return false
      }

      logUtil('shouldShowOnboardingModalProfileAction').debug('[done]')
      dispatch(updateProfileFitnessDataModalShownAtAction(createISOStrDateUtil()))
      return true
    }

    return openModalWithDelay()
  }
}
